/* eslint-disable max-len */
/**
 * A map associating post properties with their unique key strings.
 */
export const PostPropertyMap = {};
/**
 * A list of recognized post properties.
 */
export const PostPropertyList = [
    // //////////////////////// GENERAL SETTINGS /////////////////////////////////////////
    //
    // Settings for the general tab
    //
    // ///////////////////////////////////////////////////////////////////////////////////
    {
        "key": "title",
        "type": "string",
        "group": "general",
        "inputType": "text",
        "default": null,
        "title": "Post title",
        "description": "The title that will be shown on the card.",
        "multilingual": true,
    }, {
        "key": "description",
        "type": "string",
        "group": "general",
        "inputType": "textarea",
        "default": null,
        "title": "Post description",
        "description": "A short description that will be shown on the card.",
        "multilingual": true,
    }, {
        "key": "hideDefaultHeader",
        "type": "boolean",
        "group": "general",
        "inputType": "switch",
        "default": true,
        "title": "Hide default header",
        "description": "Hide the default header",
        "multilingual": false,
        "isBulkEditable": true,
    }, {
        "key": "hideDefaultFooter",
        "type": "boolean",
        "group": "general",
        "inputType": "switch",
        "default": true,
        "title": "Hide default footer",
        "description": "Hide the default footer",
        "multilingual": false,
        "isBulkEditable": true,
    }, {
        "key": "cardColor",
        "type": "string",
        "group": "general",
        "inputType": "color",
        "default": null,
        "title": "Post card color",
        "description": "Accent color to use for the post card.",
        "multilingual": false,
        "hiddenFromInterface": true,
    }, {
        "key": "lightTextColor",
        "type": "boolean",
        "group": "general",
        "inputType": "switch",
        "default": null,
        "title": "Light text color",
        "description": "Use a light text color for the card text.",
        "multilingual": false,
        "hiddenFromInterface": true,
    },
    // //////////////////////// PUBLICATION (FORMERLY CARD) SETTINGS /////////////////////////////////////////
    //
    // Settings for the publication tab
    //
    // ///////////////////////////////////////////////////////////////////////////////////
    {
        "key": "showPageNumbers",
        "type": "boolean",
        "group": "card",
        "inputType": "switch",
        "default": null,
        "title": "Show page numbering",
        "description": "Show a running page number on each page of the post.",
        "multilingual": false,
        "hiddenFromInterface": true,
    }, {
        "key": "mapCoordinatePicker",
        "type": "object",
        "group": "card",
        "inputType": "mapCoordinatePicker",
        "default": {},
        "title": "Map Coordinate picker",
        "description": "Set starting coordinates and zoom level for page.",
        "multilingual": true,
        "isBulkEditable": true,
    },
    {
        "key": "allowedEmbedHost",
        "type": "string",
        "group": "card",
        "inputType": "text",
        "default": null,
        "title": "Allow embedding on",
        "description": "The website domain URL where this page should be allowed to be embedded.",
        "multilingual": false,
        "needsLicense": "feature:post:embedding",
        "isBulkEditable": true,
    },
    // //////////////////////// INTERACTIVITY SETTINGS /////////////////////////////////////////
    //
    // Settings for the interactivity tab
    //
    // ///////////////////////////////////////////////////////////////////////////////////
    {
        "key": "sharingButtons",
        "type": "list.string",
        "default": [],
        "group": "sharing",
        "inputType": "ownOptionMany",
        "title": "Sharing buttons",
        "description": "Which social media sharing buttons to show",
        "valueOptions": ["facebook", "twitter", "linkedin", "pinterest", "reddit"],
        "valueOptionIcons": [["fab", "facebook"], ["fab", "twitter"], ["fab", "linkedin"], ["fab", "pinterest"], ["fab", "reddit"]],
        "multilingual": false,
        "isBulkEditable": true,
    }, {
        "key": "featureImageAsset",
        "type": "resourceId",
        "isResourceId": "asset",
        "inputType": "imageAssetId",
        "group": "image",
        "default": null,
        "title": "Post card image asset",
        "description": "An image asset to use as the card background.",
        "includeResourceInPreview": true,
        "multilingual": false,
        "isBulkEditable": true,
    }, {
        "key": "featureImage",
        "type": "url",
        "group": "image",
        "inputType": "imageUrl",
        "default": null,
        "title": "Post card image url",
        "description": "A URL for an image to use as the card background. This will not be used if the image asset option is selected.",
        "multilingual": true,
        "isBulkEditable": true,
    },
    {
        "key": "showFullImage",
        "type": "boolean",
        "group": "image",
        "inputType": "switch",
        "default": false,
        "title": "Show full image",
        "description": "Select this if you want the whole image to be visible. If this is not selected, the image will be scaled to fill out the card.",
        "multilingual": false,
        "isBulkEditable": true,
    }, {
        "key": "commentLength",
        "type": "number",
        "group": "sharing",
        "inputType": "integer",
        "default": 1000,
        "title": "Comment length",
        "description": "The maximum length allowed for comments.",
        "multilingual": false,
        "isBulkEditable": true,
    }, {
        // DEPRECIATED
        // DEPRECIATED
        "key": "sharingImageAsset",
        "type": "resourceId",
        "isResourceId": "asset",
        "inputType": "imageAssetId",
        "group": "image",
        "default": null,
        "title": "Sharing image asset",
        "description": "The image that Facebook and Twitter will use when showing a link to this post. If this is not set, the Card Image will be used.",
        "multilingual": true,
        "isBulkEditable": true,
        "hiddenFromInterface": true,
        // DEPRECIATED
        // DEPRECIATED
    }, {
        // DEPRECIATED
        // DEPRECIATED
        // DEPRECIATED
        "key": "sharingImage",
        "type": "url",
        "group": "image",
        "inputType": "imageUrl",
        "default": null,
        "title": "Sharing image",
        "description": "The image that Facebook and Twitter will use when showing a link to this post.",
        "multilingual": false,
        "hiddenFromInterface": true,
        // DEPRECIATED
        // DEPRECIATED
        // DEPRECIATED
    },
];
for (const property of PostPropertyList) {
    if (PostPropertyMap[property.key]) {
        throw new Error(`Duplicate post property key name "${property.key}".`);
    }
    PostPropertyMap[property.key] = property;
}
//# sourceMappingURL=postProperties.js.map